(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
function initializeHeroFilms(scope){scope.querySelectorAll('.hero-lifestyle-video').forEach(video=>{if(video.dataset.initialized)return;video.dataset.initialized='true';const reduce=window.matchMedia('(prefers-reduced-motion: reduce)');if(reduce.matches)return;const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){video.muted=true;video.play().catch(()=>{});observer.disconnect();}});},{threshold:0.25});observer.observe(video);reduce.addEventListener('change',event=>{if(event.matches){observer.disconnect();video.pause();}});});}
initializeHeroFilms(document);document.addEventListener('shopify:section:load',event=>initializeHeroFilms(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack-film"] && !Shopify.designMode) return;
  try {
    
function initializeStackFilms(scope){
  scope.querySelectorAll('[data-stack-film]').forEach(section=>{
    if(section.dataset.initialized)return;
    section.dataset.initialized='true';
    const video=section.querySelector('video');
    const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
    if(section.dataset.autoplay!=='true'||reducedMotion.matches)return;
    const observer=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(entry.isIntersecting){video.muted=true;video.play().catch(()=>{});observer.disconnect();}
      });
    },{threshold:0.25});
    observer.observe(video);
    reducedMotion.addEventListener('change',event=>{if(event.matches){observer.disconnect();video.pause();}});
  });
}
initializeStackFilms(document);
document.addEventListener('shopify:section:load',event=>initializeStackFilms(event.target));

  } catch(e) { console.error(e); }
})();
})();
